"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var DOMWalkers = {
  walk: /*#__PURE__*/_regenerator["default"].mark(function walk(rootNode) {
    var _document;
    var _len,
      treeWalkerArgs,
      _key,
      walker,
      node,
      _args = arguments;
    return _regenerator["default"].wrap(function walk$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          for (_len = _args.length, treeWalkerArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            treeWalkerArgs[_key - 1] = _args[_key];
          }
          walker = (_document = document).createTreeWalker.apply(_document, [rootNode].concat(treeWalkerArgs));
          node = walker.nextNode();
        case 3:
          if (!node) {
            _context.next = 9;
            break;
          }
          _context.next = 6;
          return node;
        case 6:
          node = walker.nextNode();
          _context.next = 3;
          break;
        case 9:
          return _context.abrupt("return");
        case 10:
        case "end":
          return _context.stop();
      }
    }, walk);
  }),
  walkBackwards: /*#__PURE__*/_regenerator["default"].mark(function walkBackwards(node) {
    var i;
    return _regenerator["default"].wrap(function walkBackwards$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (node) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return");
        case 2:
          if (!(node.childNodes.length > 0)) {
            _context2.next = 9;
            break;
          }
          i = node.childNodes.length - 1;
        case 4:
          if (!(i >= 0)) {
            _context2.next = 9;
            break;
          }
          return _context2.delegateYield(this.walkBackwards(node.childNodes[i]), "t0", 6);
        case 6:
          i--;
          _context2.next = 4;
          break;
        case 9:
          _context2.next = 11;
          return node;
        case 11:
          return _context2.abrupt("return");
        case 12:
        case "end":
          return _context2.stop();
      }
    }, walkBackwards, this);
  })
};
var _default = exports["default"] = DOMWalkers;
//# sourceMappingURL=dom-walkers.js.map